namespace Nobox.Texts {

    declare namespace Db {

        namespace Administration {

            namespace Integration {
                export const AppClientId: string;
                export const AppEndpoint: string;
                export const AppId: string;
                export const AppName: string;
                export const AppOptions: string;
                export const AppSecret: string;
                export const Id: string;
                export const In: string;
                export const Notes: string;
                export const Provider: string;
                export const TenantId: string;
                export const Up: string;
            }

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace OAuth {
                export const Data: string;
                export const Id: string;
                export const In: string;
                export const Provider: string;
                export const Token: string;
                export const User: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace Tenant {
                export const AHours: string;
                export const AMinutes: string;
                export const AccountEmail: string;
                export const AccountIds: string;
                export const Address: string;
                export const ChannelId: string;
                export const City: string;
                export const CityId: string;
                export const ConStr: string;
                export const Ctry: string;
                export const CtryId: string;
                export const Db: string;
                export const During: string;
                export const DuringMsg: string;
                export const Email: string;
                export const Friday: string;
                export const Id: string;
                export const IdtryId: string;
                export const IdtryNm: string;
                export const In: string;
                export const InvCd: string;
                export const InvCdGen: string;
                export const IsAutoArchive: string;
                export const IsAutoResolve: string;
                export const IsDlt: string;
                export const KetStatus: string;
                export const Level: string;
                export const MaxUser: string;
                export const Monday: string;
                export const Nm: string;
                export const Note: string;
                export const OfficeHours: string;
                export const Outside: string;
                export const OutsideMsg: string;
                export const Phone: string;
                export const PipelineId: string;
                export const RHours: string;
                export const RMinutes: string;
                export const Saturday: string;
                export const Server: string;
                export const StageId: string;
                export const States: string;
                export const StatesId: string;
                export const Status: string;
                export const Sunday: string;
                export const SzId: string;
                export const SzNm: string;
                export const TenantIntegration: string;
                export const TenantMembers: string;
                export const Thursday: string;
                export const Tuesday: string;
                export const Up: string;
                export const Wednesday: string;
                export const ZipCode: string;
                export const fFriday: string;
                export const fMonday: string;
                export const fSaturday: string;
                export const fSunday: string;
                export const fThursday: string;
                export const fTuesday: string;
                export const fWednesday: string;
                export const lFriday: string;
                export const lMonday: string;
                export const lSaturday: string;
                export const lSunday: string;
                export const lThursday: string;
                export const lTuesday: string;
                export const lWednesday: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const Akses: string;
                export const AssCon: string;
                export const City: string;
                export const CityId: string;
                export const Ctry: string;
                export const CtryId: string;
                export const Currencies: string;
                export const CurrenciesPlace: string;
                export const CustomDate: string;
                export const CustomTime: string;
                export const Date: string;
                export const DisplayDate: string;
                export const DisplayName: string;
                export const DisplayNumber: string;
                export const DisplayTime: string;
                export const Domain: string;
                export const Email: string;
                export const FormatDate: string;
                export const FormatNumber: string;
                export const FormatTime: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const JmlConversation: string;
                export const LastDirectoryUpdate: string;
                export const LastLogin: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const MsgSent: string;
                export const Online: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const ReCon: string;
                export const RoleIds: string;
                export const Roles: string;
                export const Source: string;
                export const States: string;
                export const StatesId: string;
                export const Status: string;
                export const TenantId: string;
                export const Timezone: string;
                export const TnNm: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
                export const aDec: string;
                export const aSep: string;
                export const dGroup: string;
                export const lZero: string;
                export const mDec: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const RoleIds: string;
                export const RoleName: string;
                export const TenantId: string;
                export const TenantNm: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace CRM {

            namespace Lognotes {
                export const Activity: string;
                export const Comment: string;
                export const Id: string;
                export const IdModul: string;
                export const NmMenu: string;
                export const Tgl: string;
                export const Type: string;
                export const Up: string;
                export const UserId: string;
                export const userImg: string;
                export const userlog: string;
            }
        }

        namespace Chat {

            namespace Agentdivisions {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Nm: string;
                export const Nt: string;
                export const SpvsId: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Chatfunnels {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Nm: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Chatlinkcontacts {
                export const AccessHash: string;
                export const Ch: string;
                export const ChId: string;
                export const Contact: string;
                export const CtId: string;
                export const ExtId: string;
                export const Extra: string;
                export const Id: string;
                export const IdExt: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Photo: string;
                export const Up: string;
                export const UpBy: string;
                export const Username: string;
            }

            namespace Chatmessages {
                export const Ack: string;
                export const AgentId: string;
                export const File: string;
                export const Files: string;
                export const From: string;
                export const GrpMember: string;
                export const Id: string;
                export const IdAlias: string;
                export const In: string;
                export const InBy: string;
                export const InteractiveMsg: string;
                export const InteractiveType: string;
                export const IsNobox: string;
                export const Msg: string;
                export const Note: string;
                export const ReplyFiles: string;
                export const ReplyFrom: string;
                export const ReplyGrpMember: string;
                export const ReplyId: string;
                export const ReplyMsg: string;
                export const ReplyType: string;
                export const RoomId: string;
                export const To: string;
                export const Type: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Chatmessageunreads {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const MsgId: string;
                export const RoomId: string;
                export const Up: string;
                export const UpBy: string;
                export const UserId: string;
            }

            namespace Chatnotes {
                export const Cnt: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const RoomId: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Chatroomagents {
                export const Ch: string;
                export const ChAccId: string;
                export const ChId: string;
                export const Ct: string;
                export const CtId: string;
                export const CtReal: string;
                export const CtRealId: string;
                export const DisplayName: string;
                export const HandId: string;
                export const HanderNm: string;
                export const Handler: string;
                export const Id: string;
                export const IdExt: string;
                export const In: string;
                export const InBy: string;
                export const LastLogin: string;
                export const LastMsg: string;
                export const RoomId: string;
                export const St: string;
                export const Up: string;
                export const UpBy: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserImage: string;
            }

            namespace Chatrooms {
                export const AccChId: string;
                export const AccData: string;
                export const AgentIds: string;
                export const Campaign: string;
                export const CampaignId: string;
                export const Ch: string;
                export const ChAcc: string;
                export const ChAccAlias: string;
                export const ChAccId: string;
                export const ChId: string;
                export const Ct: string;
                export const CtId: string;
                export const CtIdExt: string;
                export const CtImg: string;
                export const CtIsBlock: string;
                export const CtRealId: string;
                export const CtRealNm: string;
                export const Deal: string;
                export const DealId: string;
                export const Fn: string;
                export const FnId: string;
                export const FormResultId: string;
                export const FormTemplateId: string;
                export const Grp: string;
                export const GrpExtId: string;
                export const GrpId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const IsAutoArchive: string;
                export const IsAutoResolve: string;
                export const IsBlock: string;
                export const IsGrp: string;
                export const IsPin: string;
                export const LastMsg: string;
                export const LinkImg: string;
                export const ReAt: string;
                export const ReById: string;
                export const ReByNm: string;
                export const RoomAgent: string;
                export const SdrMsg: string;
                export const St: string;
                export const StNm: string;
                export const Tags: string;
                export const TagsIds: string;
                export const TimeArchived: string;
                export const TimeMsg: string;
                export const TimeResolved: string;
                export const Uc: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Chattags {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Nm: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Chattemplates {
                export const Cmd: string;
                export const Cnt: string;
                export const Files: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Up: string;
                export const UpBy: string;
            }
        }

        namespace Common {

            namespace Todo {
                export const Done: string;
                export const Id: string;
                export const In: string;
                export const Index: string;
                export const Name: string;
                export const UserId: string;
            }
        }

        namespace CustomFields {

            namespace Customfields {
                export const Data: string;
                export const Id: string;
                export const Name: string;
                export const Up: string;
                export const UpBy: string;
            }
        }

        namespace EmailQueue {

            namespace EmailQueue {
                export const AccountId: string;
                export const AccountName: string;
                export const Attachments: string;
                export const BaseUrlApi: string;
                export const Bcc: string;
                export const Body: string;
                export const Cc: string;
                export const EndpointApi: string;
                export const ErrorMessage: string;
                export const From: string;
                export const FromApi: string;
                export const Host: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsSMTP: string;
                export const KeyApi: string;
                export const LockExpiration: string;
                export const MailFrom: string;
                export const MailId: string;
                export const MailTo: string;
                export const Password: string;
                export const Port: string;
                export const Priority: string;
                export const Process: string;
                export const Provider: string;
                export const ReplyTo: string;
                export const RetryCount: string;
                export const SentDate: string;
                export const SerializedMessage: string;
                export const Settings: string;
                export const Status: string;
                export const Subject: string;
                export const TenantId: string;
                export const TenantName: string;
                export const Uid: string;
                export const UseSSL: string;
                export const Username: string;
            }

            namespace EmailQueuePerTenant {
                export const AccountId: string;
                export const AccountName: string;
                export const Attachments: string;
                export const BaseUrlApi: string;
                export const Bcc: string;
                export const Body: string;
                export const Cc: string;
                export const EndpointApi: string;
                export const ErrorMessage: string;
                export const From: string;
                export const FromApi: string;
                export const Host: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsSMTP: string;
                export const KeyApi: string;
                export const LockExpiration: string;
                export const MailFrom: string;
                export const MailId: string;
                export const MailTo: string;
                export const Password: string;
                export const Port: string;
                export const Priority: string;
                export const Process: string;
                export const Provider: string;
                export const ReplyTo: string;
                export const RetryCount: string;
                export const SentDate: string;
                export const SerializedMessage: string;
                export const Settings: string;
                export const Status: string;
                export const Subject: string;
                export const TenantId: string;
                export const Uid: string;
                export const UseSSL: string;
                export const Username: string;
            }
        }

        namespace Master {

            namespace Asset {
                export const Id: string;
                export const In: string;
                export const Isi: string;
                export const Kd: string;
                export const Ket: string;
                export const Kt: string;
                export const Nm: string;
                export const Up: string;
            }

            namespace Channel {
                export const Country: string;
                export const CountryId: string;
                export const Data: string;
                export const Id: string;
                export const In: string;
                export const Kd: string;
                export const Ket: string;
                export const Kt: string;
                export const Nm: string;
                export const Pg: string;
                export const St: string;
                export const Sym: string;
                export const Up: string;
                export const Url: string;
                export const VersionDate: string;
                export const VersionName: string;
            }

            namespace Cities {
                export const CountryCode: string;
                export const CountryId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Latitude: string;
                export const Longitude: string;
                export const Name: string;
                export const Notes: string;
                export const StateCode: string;
                export const StateId: string;
                export const Up: string;
                export const UpBy: string;
                export const WikiDataId: string;
            }

            namespace Contactsite {
                export const Category: string;
                export const Country: string;
                export const Developer: string;
                export const Domain: string;
                export const DoneDate: string;
                export const HasilTest: string;
                export const Id: string;
                export const In: string;
                export const Network: string;
                export const Progress: string;
                export const Tester: string;
                export const Up: string;
                export const Url: string;
            }

            namespace Countries {
                export const Capital: string;
                export const Currency: string;
                export const CurrencySymbol: string;
                export const DefaultFormat: string;
                export const Emoji: string;
                export const EmojiU: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Iso2: string;
                export const Iso3: string;
                export const Latitude: string;
                export const Longitude: string;
                export const Name: string;
                export const Native: string;
                export const Notes: string;
                export const NumericCode: string;
                export const PhoneCode: string;
                export const Region: string;
                export const SubRegion: string;
                export const Timezones: string;
                export const Tld: string;
                export const Translations: string;
                export const Up: string;
                export const UpBy: string;
                export const WikiDataId: string;
            }

            namespace Industries {
                export const Id: string;
                export const Nm: string;
            }

            namespace Linkbantuan {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Kd: string;
                export const Ket: string;
                export const Up: string;
                export const UpBy: string;
                export const Url: string;
            }

            namespace Optionregisters {
                export const Id: string;
                export const Nm: string;
            }

            namespace SettingPerLanguage {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Language: string;
                export const Name: string;
                export const Notes: string;
                export const Setting: string;
                export const Type: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Sinonim {
                export const Bhs: string;
                export const Hsl: string;
                export const Id: string;
                export const In: string;
                export const Kt: string;
                export const Up: string;
            }

            namespace Sizetenants {
                export const Id: string;
                export const Nm: string;
            }

            namespace States {
                export const CountryCode: string;
                export const CountryId: string;
                export const FipsCode: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Iso2: string;
                export const Latitude: string;
                export const Longitude: string;
                export const Name: string;
                export const Notes: string;
                export const Up: string;
                export const UpBy: string;
                export const WikiDataId: string;
            }

            namespace Terjemah {
                export const Id: string;
                export const In: string;
                export const Kd: string;
                export const Lang: string;
                export const Localize: string;
                export const Nm: string;
                export const Up: string;
            }

            namespace Timezone {
                export const CountryCode: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Notes: string;
                export const Offset: string;
                export const Up: string;
                export const UpBy: string;
            }
        }

        namespace NoBoxCRM {

            namespace Divisions {
                export const AgentIds: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Spv: string;
                export const SpvId: string;
                export const Up: string;
                export const UpBy: string;
                export const listAgent: string;
            }

            namespace Form {
                export const BData: string;
                export const Btxt: string;
                export const Data: string;
                export const DataMail: string;
                export const DataSendURL: string;
                export const DataWa: string;
                export const FollowUp: string;
                export const HData: string;
                export const HLogo: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const IsSendMail: string;
                export const IsSendURL: string;
                export const IsSendWa: string;
                export const Layout: string;
                export const Name: string;
                export const Payment: string;
                export const Product: string;
                export const ProductId: string;
                export const Results: string;
                export const ShowCaptcha: string;
                export const ShowCoupon: string;
                export const ShowLabel: string;
                export const SuccessData: string;
                export const SuccessType: string;
                export const TagIds: string;
                export const Type: string;
                export const Up: string;
                export const UpBy: string;
                export const VideoUrl: string;
                export const accMail: string;
                export const accWa: string;
                export const toMail: string;
                export const toWa: string;
            }

            namespace Formpayments {
                export const Active: string;
                export const Extra: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Instruct: string;
                export const Name: string;
                export const Note: string;
                export const QrCode: string;
                export const TnId: string;
                export const Type: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Formresults {
                export const Data: string;
                export const DateIn: string;
                export const FollowUp: string;
                export const Form: string;
                export const FormId: string;
                export const FrmDataMail: string;
                export const FrmDataWa: string;
                export const FrmFollowUp: string;
                export const FrmIsSendMail: string;
                export const FrmIsSendWa: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const IsPaid: string;
                export const Phone: string;
                export const Products: string;
                export const SenderNm: string;
                export const St: string;
                export const TagIds: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Formtags {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Nm: string;
                export const Up: string;
                export const UpBy: string;
            }
        }

        namespace Nobox {

            namespace Account {
                export const ApiClient: string;
                export const ApiExtra: string;
                export const ApiId: string;
                export const ApiSecret: string;
                export const BaseUrlApi: string;
                export const BotActive: string;
                export const BotChannel: string;
                export const BotEndpoint: string;
                export const BotEngine: string;
                export const BotName: string;
                export const BotOptions: string;
                export const BotPassword: string;
                export const BotUsername: string;
                export const Category: string;
                export const Channel: string;
                export const ChannelNm: string;
                export const Code: string;
                export const EndpointApi: string;
                export const From: string;
                export const FromApi: string;
                export const Host: string;
                export const Id: string;
                export const In: string;
                export const Info: string;
                export const IsSMTP: string;
                export const KeyApi: string;
                export const Name: string;
                export const Password: string;
                export const Port: string;
                export const Provider: string;
                export const Status: string;
                export const Symbol: string;
                export const TenantId: string;
                export const Up: string;
                export const UseSSL: string;
                export const Username: string;
                export const Users: string;
            }

            namespace Accountings {
                export const Amount: string;
                export const Attachment: string;
                export const CtId: string;
                export const Currencies: string;
                export const Date: string;
                export const DealId: string;
                export const DealNm: string;
                export const Desc: string;
                export const FromName: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Payment: string;
                export const PlId: string;
                export const ReferenceNumber: string;
                export const TnId: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Campaign {
                export const AccountIds: string;
                export const Attachment: string;
                export const Body: string;
                export const BodyText: string;
                export const BodyType: string;
                export const ChannelId: string;
                export const ChannelNm: string;
                export const ColumnExcel: string;
                export const DataExcel: string;
                export const DataLookupBy: string;
                export const Desc: string;
                export const DvsId: string;
                export const End: string;
                export const GenerateMessage: string;
                export const Groups: string;
                export const Id: string;
                export const In: string;
                export const InteractiveMsg: string;
                export const IsPerContact: string;
                export const IsSchedule: string;
                export const ListIds: string;
                export const Name: string;
                export const PerDay: string;
                export const ResultDataExcel: string;
                export const Schedule: string;
                export const ShortLink: string;
                export const Start: string;
                export const Status: string;
                export const Subject: string;
                export const Tags: string;
                export const TenantId: string;
                export const Up: string;
            }

            namespace CampaignTags {
                export const Id: string;
                export const Name: string;
            }

            namespace CampaignTemplate {
                export const Attachment: string;
                export const Body: string;
                export const BodyHtml: string;
                export const BodyText: string;
                export const BodyType: string;
                export const ChannelId: string;
                export const ChannelNm: string;
                export const Id: string;
                export const In: string;
                export const InteractiveMsg: string;
                export const Name: string;
                export const Subject: string;
                export const Template: string;
                export const TenantId: string;
                export const Up: string;
            }

            namespace Campaignresult {
                export const Attachment: string;
                export const Body: string;
                export const BodyHtml: string;
                export const BodyText: string;
                export const BodyType: string;
                export const Campaign: string;
                export const CampaignId: string;
                export const CampaignSource: string;
                export const ChannelId: string;
                export const Contact: string;
                export const ContactId: string;
                export const ContactLinkId: string;
                export const Created: string;
                export const Email: string;
                export const Group: string;
                export const GroupName: string;
                export const Id: string;
                export const InteractiveMsg: string;
                export const IsDirect: string;
                export const IsRead: string;
                export const Note: string;
                export const ProcessBy: string;
                export const ProcessDate: string;
                export const ReadDate: string;
                export const Sent: string;
                export const ShortLink: string;
                export const Status: string;
                export const Subject: string;
                export const Tags: string;
                export const TenantId: string;
                export const Unik: string;
                export const Up: string;
            }

            namespace ContactTags {
                export const Id: string;
                export const Name: string;
            }

            namespace Dealcomments {
                export const Comment: string;
                export const Id: string;
                export const TaskId: string;
                export const UserId: string;
                export const WriteDate: string;
            }

            namespace Dealcontacts {
                export const CtId: string;
                export const CtNm: string;
                export const DealId: string;
                export const GrpId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Dealpipelines {
                export const Act: string;
                export const AliasId: string;
                export const AliasNm: string;
                export const Description: string;
                export const GrpId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const InByNm: string;
                export const Nm: string;
                export const PrivacyVisibility: string;
                export const RatingStatus: string;
                export const RatingStatusPeriod: string;
                export const Tags: string;
                export const TypeList: string;
                export const TypeListDel: string;
                export const Up: string;
                export const UpBy: string;
                export const UpByNm: string;
            }

            namespace Dealpipelinetags {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const LegendBlocked: string;
                export const LegendDone: string;
                export const LegendNormal: string;
                export const Nm: string;
                export const ProjectId: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Dealpipelinetypes {
                export const Active: string;
                export const AutoValidationKanbanState: string;
                export const CreateDate: string;
                export const CreateUid: string;
                export const Description: string;
                export const Fold: string;
                export const Id: string;
                export const IsClosed: string;
                export const LegendBlocked: string;
                export const LegendDone: string;
                export const LegendNormal: string;
                export const MailTemplateId: string;
                export const Name: string;
                export const ProjectName: string;
                export const RatingTemplateId: string;
                export const Sequence: string;
                export const UserId: string;
                export const WriteDate: string;
                export const WriteUid: string;
                export const project_id: string;
                export const stgindex: string;
            }

            namespace Deals {
                export const Assign: string;
                export const ClsDt: string;
                export const Comments: string;
                export const CryId: string;
                export const CtDeal: string;
                export const CtIds: string;
                export const ExpDt: string;
                export const Grp: string;
                export const GrpId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Index: string;
                export const IsDone: string;
                export const LostR: string;
                export const LostRId: string;
                export const Nm: string;
                export const Pdt: string;
                export const PdtIds: string;
                export const Pdts: string;
                export const PlId: string;
                export const PlTags: string;
                export const Prc: string;
                export const PriorityId: string;
                export const Src: string;
                export const SrcId: string;
                export const StDt: string;
                export const Up: string;
                export const UpBy: string;
                export const piplinetypes: string;
            }

            namespace Expensecategory {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Expenses {
                export const Category: string;
                export const ContactIds: string;
                export const Currencies: string;
                export const DealIds: string;
                export const Description: string;
                export const ExpenseAmount: string;
                export const ExspenseDate: string;
                export const GroupIds: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Up: string;
                export const UpBy: string;
                export const Upload: string;
            }

            namespace Group {
                export const AccountIds: string;
                export const ChannelId: string;
                export const Desc: string;
                export const ExtId: string;
                export const Id: string;
                export const In: string;
                export const Name: string;
                export const Up: string;
            }

            namespace Groups {
                export const Address: string;
                export const City: string;
                export const Country: string;
                export const Grp: string;
                export const GrpId: string;
                export const Id: string;
                export const Image: string;
                export const In: string;
                export const InBy: string;
                export const Industry: string;
                export const Latitude: string;
                export const Longitude: string;
                export const Name: string;
                export const Owner: string;
                export const OwnerId: string;
                export const Source: string;
                export const State: string;
                export const Telephone: string;
                export const TnId: string;
                export const Type: string;
                export const Up: string;
                export const UpBy: string;
                export const Web: string;
                export const ZipCode: string;
            }

            namespace Grouptargets {
                export const Agus: string;
                export const Apr: string;
                export const Cry: string;
                export const Currencies: string;
                export const Dec: string;
                export const Feb: string;
                export const Grp: string;
                export const GrpId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Jan: string;
                export const Jul: string;
                export const Jun: string;
                export const Mar: string;
                export const May: string;
                export const Nov: string;
                export const Okto: string;
                export const Sep: string;
                export const Target: string;
                export const Total: string;
                export const Up: string;
                export const UpBy: string;
                export const Years: string;
            }

            namespace Lead {
                export const Address: string;
                export const Category: string;
                export const City: string;
                export const Country: string;
                export const Custom: string;
                export const ExtSites: string;
                export const Id: string;
                export const In: string;
                export const IsBlock: string;
                export const Latitude: string;
                export const LinkId: string;
                export const ListId: string;
                export const LocatedIn: string;
                export const Location: string;
                export const Longitude: string;
                export const Manager: string;
                export const Name: string;
                export const Notes: string;
                export const OpenHours: string;
                export const Photo: string;
                export const Postal: string;
                export const Progress: string;
                export const Rating: string;
                export const Reviews: string;
                export const Search: string;
                export const State: string;
                export const Tags: string;
                export const Tool: string;
                export const Unik: string;
                export const Up: string;
                export const Url: string;
                export const User: string;
                export const VatNumber: string;
                export const Website: string;
            }

            namespace List {
                export const Contact: string;
                export const Id: string;
                export const In: string;
                export const Nm: string;
                export const Up: string;
            }

            namespace Notif {
                export const Action: string;
                export const Icon: string;
                export const Id: string;
                export const IsRead: string;
                export const Menu: string;
                export const Message: string;
                export const RepeatAction: string;
                export const Time: string;
                export const Title: string;
                export const ToServer: string;
                export const UserId: string;
            }

            namespace Payments {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Pluginsession {
                export const Account: string;
                export const AccountId: string;
                export const Data: string;
                export const Id: string;
                export const In: string;
                export const TenantId: string;
                export const Tool: string;
                export const Up: string;
            }

            namespace Pluginsetting {
                export const Back: string;
                export const Id: string;
                export const In: string;
                export const Isi: string;
                export const Kd: string;
                export const Ket: string;
                export const Kt: string;
                export const TenantId: string;
                export const Unik: string;
                export const Up: string;
            }

            namespace Productdeals {
                export const Currencies: string;
                export const DealId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const PdtCd: string;
                export const PdtDesc: string;
                export const PdtDisc: string;
                export const PdtId: string;
                export const PdtIdNm: string;
                export const PdtImg: string;
                export const PdtPrc: string;
                export const PdtQty: string;
                export const PdtTotal: string;
                export const UnitIds: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Products {
                export const Currencies: string;
                export const Custom: string;
                export const Discount: string;
                export const Extra: string;
                export const FinalTotalPrice: string;
                export const Id: string;
                export const IdExt: string;
                export const IdExternal: string;
                export const Image: string;
                export const In: string;
                export const InBy: string;
                export const IsShowForm: string;
                export const ManufacturIds: string;
                export const PriceList: string;
                export const ProductCode: string;
                export const ProductDesc: string;
                export const ProductName: string;
                export const Quantity: string;
                export const Tags: string;
                export const TnId: string;
                export const TotalPrice: string;
                export const UnitIds: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Producttags {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Statistik {
                export const ChannelId: string;
                export const Id: string;
                export const T10B: string;
                export const T10E: string;
                export const T11B: string;
                export const T11E: string;
                export const T12B: string;
                export const T12E: string;
                export const T13B: string;
                export const T13E: string;
                export const T14B: string;
                export const T14E: string;
                export const T15B: string;
                export const T15E: string;
                export const T16B: string;
                export const T16E: string;
                export const T17B: string;
                export const T17E: string;
                export const T18B: string;
                export const T18E: string;
                export const T19B: string;
                export const T19E: string;
                export const T1B: string;
                export const T1E: string;
                export const T20B: string;
                export const T20E: string;
                export const T21B: string;
                export const T21E: string;
                export const T22B: string;
                export const T22E: string;
                export const T23B: string;
                export const T23E: string;
                export const T24B: string;
                export const T24E: string;
                export const T25B: string;
                export const T25E: string;
                export const T26B: string;
                export const T26E: string;
                export const T27B: string;
                export const T27E: string;
                export const T28B: string;
                export const T28E: string;
                export const T29B: string;
                export const T29E: string;
                export const T2B: string;
                export const T2E: string;
                export const T30B: string;
                export const T30E: string;
                export const T31B: string;
                export const T31E: string;
                export const T3B: string;
                export const T3E: string;
                export const T4B: string;
                export const T4E: string;
                export const T5B: string;
                export const T5E: string;
                export const T6B: string;
                export const T6E: string;
                export const T7B: string;
                export const T7E: string;
                export const T8B: string;
                export const T8E: string;
                export const T9B: string;
                export const T9E: string;
                export const TenantId: string;
                export const ThBln: string;
            }

            namespace Task {
                export const BoardId: string;
                export const Color: string;
                export const Comments: string;
                export const DealId: string;
                export const GroupId: string;
                export const Hasil: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const InByNm: string;
                export const Index: string;
                export const IsDone: string;
                export const KategoriId: string;
                export const Ket: string;
                export const KontakFoto: string;
                export const KontakId: string;
                export const KontakNama: string;
                export const Lampiran: string;
                export const ListId: string;
                export const ListIn: string;
                export const ListInBy: string;
                export const ListNama: string;
                export const ListUp: string;
                export const ListUpBy: string;
                export const Mulai: string;
                export const Nama: string;
                export const Owner: string;
                export const Selesai: string;
                export const ShowBoard: string;
                export const Tags: string;
                export const TnId: string;
                export const Up: string;
                export const UpBy: string;
                export const UpByNm: string;
            }

            namespace Taskboard {
                export const BoardList: string;
                export const BoardListEntity: string;
                export const BoardListOri: string;
                export const Deskripsi: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const InByNm: string;
                export const Nama: string;
                export const Up: string;
                export const UpBy: string;
                export const UpByNm: string;
            }

            namespace Taskboardlist {
                export const BoardDeskripsi: string;
                export const BoardId: string;
                export const BoardIn: string;
                export const BoardInBy: string;
                export const BoardNama: string;
                export const BoardUp: string;
                export const BoardUpBy: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const ListId: string;
                export const ListIn: string;
                export const ListInBy: string;
                export const ListNama: string;
                export const ListUp: string;
                export const ListUpBy: string;
                export const Up: string;
                export const UpBy: string;
                export const Urutan: string;
            }

            namespace Taskcategories {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Name: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Taskcomment {
                export const BoardId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const TaskBoardId: string;
                export const TaskColor: string;
                export const TaskId: string;
                export const TaskIn: string;
                export const TaskInBy: string;
                export const TaskIndex: string;
                export const TaskKet: string;
                export const TaskKontakId: string;
                export const TaskLampiran: string;
                export const TaskListId: string;
                export const TaskMulai: string;
                export const TaskNama: string;
                export const TaskSelesai: string;
                export const TaskTags: string;
                export const TaskUp: string;
                export const TaskUpBy: string;
                export const Text: string;
                export const Up: string;
                export const UpBy: string;
                export const UserId: string;
            }

            namespace Taskcontacts {
                export const CtId: string;
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const TaskCtgyId: string;
                export const TaskDueDate: string;
                export const TaskId: string;
                export const TaskNm: string;
                export const TaskPriId: string;
                export const TaskReminderDate: string;
                export const TaskSt: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Tasklist {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Nama: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Taskpriorities {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const Nm: string;
                export const Up: string;
                export const UpBy: string;
            }

            namespace Tasktag {
                export const Id: string;
                export const In: string;
                export const InBy: string;
                export const InByNm: string;
                export const Nama: string;
                export const Up: string;
                export const UpBy: string;
                export const UpByNm: string;
                export const isLookup: string;
            }
        }

        namespace NoboxChat {

            namespace Chatmessagearchives {
                export const Id: string;
                export const Msgs: string;
                export const RoomId: string;
                export const St: string;
            }

            namespace Chatroomtagsfunnel {
                export const Id: string;
                export const In: string;
                export const RoomId: string;
                export const Type: string;
                export const TypeId: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const ClickHere: string;
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const NeedHelp: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignTo: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const Already: string;
                export const BackToLogin: string;
                export const CityId: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const CtryId: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const InvCd: string;
                export const MobilePhoneNumber: string;
                export const Opt: string;
                export const Password: string;
                export const StatesId: string;
                export const SubmitButton: string;
                export const Success: string;
                export const TnCityId: string;
                export const TnCtryId: string;
                export const TnEmail: string;
                export const TnIdtry: string;
                export const TnNm: string;
                export const TnPhone: string;
                export const TnSize: string;
                export const TnStateId: string;
            }
        }
    }

    declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace TimeAgo {
            export const day: string;
            export const days: string;
            export const hour: string;
            export const hours: string;
            export const inPast: string;
            export const minute: string;
            export const minutes: string;
            export const month: string;
            export const months: string;
            export const seconds: string;
            export const suffixAgo: string;
            export const suffixFromNow: string;
            export const wordSeparator: string;
            export const year: string;
            export const years: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    Nobox['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{Integration:{AppClientId:1,AppEndpoint:1,AppId:1,AppName:1,AppOptions:1,AppSecret:1,Id:1,In:1,Notes:1,Provider:1,TenantId:1,Up:1},Language:{Id:1,LanguageId:1,LanguageName:1},OAuth:{Data:1,Id:1,In:1,Provider:1,Token:1,User:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},Tenant:{AHours:1,AMinutes:1,AccountEmail:1,AccountIds:1,Address:1,ChannelId:1,City:1,CityId:1,ConStr:1,Ctry:1,CtryId:1,Db:1,During:1,DuringMsg:1,Email:1,Friday:1,Id:1,IdtryId:1,IdtryNm:1,In:1,InvCd:1,InvCdGen:1,IsAutoArchive:1,IsAutoResolve:1,IsDlt:1,KetStatus:1,Level:1,MaxUser:1,Monday:1,Nm:1,Note:1,OfficeHours:1,Outside:1,OutsideMsg:1,Phone:1,PipelineId:1,RHours:1,RMinutes:1,Saturday:1,Server:1,StageId:1,States:1,StatesId:1,Status:1,Sunday:1,SzId:1,SzNm:1,TenantIntegration:1,TenantMembers:1,Thursday:1,Tuesday:1,Up:1,Wednesday:1,ZipCode:1,fFriday:1,fMonday:1,fSaturday:1,fSunday:1,fThursday:1,fTuesday:1,fWednesday:1,lFriday:1,lMonday:1,lSaturday:1,lSunday:1,lThursday:1,lTuesday:1,lWednesday:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{Akses:1,AssCon:1,City:1,CityId:1,Ctry:1,CtryId:1,Currencies:1,CurrenciesPlace:1,CustomDate:1,CustomTime:1,Date:1,DisplayDate:1,DisplayName:1,DisplayNumber:1,DisplayTime:1,Domain:1,Email:1,FormatDate:1,FormatNumber:1,FormatTime:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,JmlConversation:1,LastDirectoryUpdate:1,LastLogin:1,MobilePhoneNumber:1,MobilePhoneVerified:1,MsgSent:1,Online:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,ReCon:1,RoleIds:1,Roles:1,Source:1,States:1,StatesId:1,Status:1,TenantId:1,Timezone:1,TnNm:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1,aDec:1,aSep:1,dGroup:1,lZero:1,mDec:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,RoleIds:1,RoleName:1,TenantId:1,TenantNm:1,User:1,UserId:1,UserRoleId:1,Username:1}},CRM:{Lognotes:{Activity:1,Comment:1,Id:1,IdModul:1,NmMenu:1,Tgl:1,Type:1,Up:1,UserId:1,userImg:1,userlog:1}},Chat:{Agentdivisions:{Id:1,In:1,InBy:1,Nm:1,Nt:1,SpvsId:1,Up:1,UpBy:1},Chatfunnels:{Id:1,In:1,InBy:1,Nm:1,Up:1,UpBy:1},Chatlinkcontacts:{AccessHash:1,Ch:1,ChId:1,Contact:1,CtId:1,ExtId:1,Extra:1,Id:1,IdExt:1,In:1,InBy:1,Name:1,Photo:1,Up:1,UpBy:1,Username:1},Chatmessages:{Ack:1,AgentId:1,File:1,Files:1,From:1,GrpMember:1,Id:1,IdAlias:1,In:1,InBy:1,InteractiveMsg:1,InteractiveType:1,IsNobox:1,Msg:1,Note:1,ReplyFiles:1,ReplyFrom:1,ReplyGrpMember:1,ReplyId:1,ReplyMsg:1,ReplyType:1,RoomId:1,To:1,Type:1,Up:1,UpBy:1},Chatmessageunreads:{Id:1,In:1,InBy:1,MsgId:1,RoomId:1,Up:1,UpBy:1,UserId:1},Chatnotes:{Cnt:1,Id:1,In:1,InBy:1,RoomId:1,Up:1,UpBy:1},Chatroomagents:{Ch:1,ChAccId:1,ChId:1,Ct:1,CtId:1,CtReal:1,CtRealId:1,DisplayName:1,HandId:1,HanderNm:1,Handler:1,Id:1,IdExt:1,In:1,InBy:1,LastLogin:1,LastMsg:1,RoomId:1,St:1,Up:1,UpBy:1,UserEmail:1,UserId:1,UserImage:1},Chatrooms:{AccChId:1,AccData:1,AgentIds:1,Campaign:1,CampaignId:1,Ch:1,ChAcc:1,ChAccAlias:1,ChAccId:1,ChId:1,Ct:1,CtId:1,CtIdExt:1,CtImg:1,CtIsBlock:1,CtRealId:1,CtRealNm:1,Deal:1,DealId:1,Fn:1,FnId:1,FormResultId:1,FormTemplateId:1,Grp:1,GrpExtId:1,GrpId:1,Id:1,In:1,InBy:1,IsAutoArchive:1,IsAutoResolve:1,IsBlock:1,IsGrp:1,IsPin:1,LastMsg:1,LinkImg:1,ReAt:1,ReById:1,ReByNm:1,RoomAgent:1,SdrMsg:1,St:1,StNm:1,Tags:1,TagsIds:1,TimeArchived:1,TimeMsg:1,TimeResolved:1,Uc:1,Up:1,UpBy:1},Chattags:{Id:1,In:1,InBy:1,Nm:1,Up:1,UpBy:1},Chattemplates:{Cmd:1,Cnt:1,Files:1,Id:1,In:1,InBy:1,Up:1,UpBy:1}},Common:{Todo:{Done:1,Id:1,In:1,Index:1,Name:1,UserId:1}},CustomFields:{Customfields:{Data:1,Id:1,Name:1,Up:1,UpBy:1}},EmailQueue:{EmailQueue:{AccountId:1,AccountName:1,Attachments:1,BaseUrlApi:1,Bcc:1,Body:1,Cc:1,EndpointApi:1,ErrorMessage:1,From:1,FromApi:1,Host:1,InsertDate:1,InsertUserId:1,IsSMTP:1,KeyApi:1,LockExpiration:1,MailFrom:1,MailId:1,MailTo:1,Password:1,Port:1,Priority:1,Process:1,Provider:1,ReplyTo:1,RetryCount:1,SentDate:1,SerializedMessage:1,Settings:1,Status:1,Subject:1,TenantId:1,TenantName:1,Uid:1,UseSSL:1,Username:1},EmailQueuePerTenant:{AccountId:1,AccountName:1,Attachments:1,BaseUrlApi:1,Bcc:1,Body:1,Cc:1,EndpointApi:1,ErrorMessage:1,From:1,FromApi:1,Host:1,InsertDate:1,InsertUserId:1,IsSMTP:1,KeyApi:1,LockExpiration:1,MailFrom:1,MailId:1,MailTo:1,Password:1,Port:1,Priority:1,Process:1,Provider:1,ReplyTo:1,RetryCount:1,SentDate:1,SerializedMessage:1,Settings:1,Status:1,Subject:1,TenantId:1,Uid:1,UseSSL:1,Username:1}},Master:{Asset:{Id:1,In:1,Isi:1,Kd:1,Ket:1,Kt:1,Nm:1,Up:1},Channel:{Country:1,CountryId:1,Data:1,Id:1,In:1,Kd:1,Ket:1,Kt:1,Nm:1,Pg:1,St:1,Sym:1,Up:1,Url:1,VersionDate:1,VersionName:1},Cities:{CountryCode:1,CountryId:1,Id:1,In:1,InBy:1,Latitude:1,Longitude:1,Name:1,Notes:1,StateCode:1,StateId:1,Up:1,UpBy:1,WikiDataId:1},Contactsite:{Category:1,Country:1,Developer:1,Domain:1,DoneDate:1,HasilTest:1,Id:1,In:1,Network:1,Progress:1,Tester:1,Up:1,Url:1},Countries:{Capital:1,Currency:1,CurrencySymbol:1,DefaultFormat:1,Emoji:1,EmojiU:1,Id:1,In:1,InBy:1,Iso2:1,Iso3:1,Latitude:1,Longitude:1,Name:1,Native:1,Notes:1,NumericCode:1,PhoneCode:1,Region:1,SubRegion:1,Timezones:1,Tld:1,Translations:1,Up:1,UpBy:1,WikiDataId:1},Industries:{Id:1,Nm:1},Linkbantuan:{Id:1,In:1,InBy:1,Kd:1,Ket:1,Up:1,UpBy:1,Url:1},Optionregisters:{Id:1,Nm:1},SettingPerLanguage:{Id:1,In:1,InBy:1,Language:1,Name:1,Notes:1,Setting:1,Type:1,Up:1,UpBy:1},Sinonim:{Bhs:1,Hsl:1,Id:1,In:1,Kt:1,Up:1},Sizetenants:{Id:1,Nm:1},States:{CountryCode:1,CountryId:1,FipsCode:1,Id:1,In:1,InBy:1,Iso2:1,Latitude:1,Longitude:1,Name:1,Notes:1,Up:1,UpBy:1,WikiDataId:1},Terjemah:{Id:1,In:1,Kd:1,Lang:1,Localize:1,Nm:1,Up:1},Timezone:{CountryCode:1,Id:1,In:1,InBy:1,Name:1,Notes:1,Offset:1,Up:1,UpBy:1}},NoBoxCRM:{Divisions:{AgentIds:1,Id:1,In:1,InBy:1,Name:1,Spv:1,SpvId:1,Up:1,UpBy:1,listAgent:1},Form:{BData:1,Btxt:1,Data:1,DataMail:1,DataSendURL:1,DataWa:1,FollowUp:1,HData:1,HLogo:1,Id:1,In:1,InBy:1,IsSendMail:1,IsSendURL:1,IsSendWa:1,Layout:1,Name:1,Payment:1,Product:1,ProductId:1,Results:1,ShowCaptcha:1,ShowCoupon:1,ShowLabel:1,SuccessData:1,SuccessType:1,TagIds:1,Type:1,Up:1,UpBy:1,VideoUrl:1,accMail:1,accWa:1,toMail:1,toWa:1},Formpayments:{Active:1,Extra:1,Id:1,In:1,InBy:1,Instruct:1,Name:1,Note:1,QrCode:1,TnId:1,Type:1,Up:1,UpBy:1},Formresults:{Data:1,DateIn:1,FollowUp:1,Form:1,FormId:1,FrmDataMail:1,FrmDataWa:1,FrmFollowUp:1,FrmIsSendMail:1,FrmIsSendWa:1,Id:1,In:1,InBy:1,IsPaid:1,Phone:1,Products:1,SenderNm:1,St:1,TagIds:1,Up:1,UpBy:1},Formtags:{Id:1,In:1,InBy:1,Nm:1,Up:1,UpBy:1}},Nobox:{Account:{ApiClient:1,ApiExtra:1,ApiId:1,ApiSecret:1,BaseUrlApi:1,BotActive:1,BotChannel:1,BotEndpoint:1,BotEngine:1,BotName:1,BotOptions:1,BotPassword:1,BotUsername:1,Category:1,Channel:1,ChannelNm:1,Code:1,EndpointApi:1,From:1,FromApi:1,Host:1,Id:1,In:1,Info:1,IsSMTP:1,KeyApi:1,Name:1,Password:1,Port:1,Provider:1,Status:1,Symbol:1,TenantId:1,Up:1,UseSSL:1,Username:1,Users:1},Accountings:{Amount:1,Attachment:1,CtId:1,Currencies:1,Date:1,DealId:1,DealNm:1,Desc:1,FromName:1,Id:1,In:1,InBy:1,Payment:1,PlId:1,ReferenceNumber:1,TnId:1,Up:1,UpBy:1},Campaign:{AccountIds:1,Attachment:1,Body:1,BodyText:1,BodyType:1,ChannelId:1,ChannelNm:1,ColumnExcel:1,DataExcel:1,DataLookupBy:1,Desc:1,DvsId:1,End:1,GenerateMessage:1,Groups:1,Id:1,In:1,InteractiveMsg:1,IsPerContact:1,IsSchedule:1,ListIds:1,Name:1,PerDay:1,ResultDataExcel:1,Schedule:1,ShortLink:1,Start:1,Status:1,Subject:1,Tags:1,TenantId:1,Up:1},CampaignTags:{Id:1,Name:1},CampaignTemplate:{Attachment:1,Body:1,BodyHtml:1,BodyText:1,BodyType:1,ChannelId:1,ChannelNm:1,Id:1,In:1,InteractiveMsg:1,Name:1,Subject:1,Template:1,TenantId:1,Up:1},Campaignresult:{Attachment:1,Body:1,BodyHtml:1,BodyText:1,BodyType:1,Campaign:1,CampaignId:1,CampaignSource:1,ChannelId:1,Contact:1,ContactId:1,ContactLinkId:1,Created:1,Email:1,Group:1,GroupName:1,Id:1,InteractiveMsg:1,IsDirect:1,IsRead:1,Note:1,ProcessBy:1,ProcessDate:1,ReadDate:1,Sent:1,ShortLink:1,Status:1,Subject:1,Tags:1,TenantId:1,Unik:1,Up:1},ContactTags:{Id:1,Name:1},Dealcomments:{Comment:1,Id:1,TaskId:1,UserId:1,WriteDate:1},Dealcontacts:{CtId:1,CtNm:1,DealId:1,GrpId:1,Id:1,In:1,InBy:1,Up:1,UpBy:1},Dealpipelines:{Act:1,AliasId:1,AliasNm:1,Description:1,GrpId:1,Id:1,In:1,InBy:1,InByNm:1,Nm:1,PrivacyVisibility:1,RatingStatus:1,RatingStatusPeriod:1,Tags:1,TypeList:1,TypeListDel:1,Up:1,UpBy:1,UpByNm:1},Dealpipelinetags:{Id:1,In:1,InBy:1,LegendBlocked:1,LegendDone:1,LegendNormal:1,Nm:1,ProjectId:1,Up:1,UpBy:1},Dealpipelinetypes:{Active:1,AutoValidationKanbanState:1,CreateDate:1,CreateUid:1,Description:1,Fold:1,Id:1,IsClosed:1,LegendBlocked:1,LegendDone:1,LegendNormal:1,MailTemplateId:1,Name:1,ProjectName:1,RatingTemplateId:1,Sequence:1,UserId:1,WriteDate:1,WriteUid:1,project_id:1,stgindex:1},Deals:{Assign:1,ClsDt:1,Comments:1,CryId:1,CtDeal:1,CtIds:1,ExpDt:1,Grp:1,GrpId:1,Id:1,In:1,InBy:1,Index:1,IsDone:1,LostR:1,LostRId:1,Nm:1,Pdt:1,PdtIds:1,Pdts:1,PlId:1,PlTags:1,Prc:1,PriorityId:1,Src:1,SrcId:1,StDt:1,Up:1,UpBy:1,piplinetypes:1},Expensecategory:{Id:1,In:1,InBy:1,Name:1,Up:1,UpBy:1},Expenses:{Category:1,ContactIds:1,Currencies:1,DealIds:1,Description:1,ExpenseAmount:1,ExspenseDate:1,GroupIds:1,Id:1,In:1,InBy:1,Up:1,UpBy:1,Upload:1},Group:{AccountIds:1,ChannelId:1,Desc:1,ExtId:1,Id:1,In:1,Name:1,Up:1},Groups:{Address:1,City:1,Country:1,Grp:1,GrpId:1,Id:1,Image:1,In:1,InBy:1,Industry:1,Latitude:1,Longitude:1,Name:1,Owner:1,OwnerId:1,Source:1,State:1,Telephone:1,TnId:1,Type:1,Up:1,UpBy:1,Web:1,ZipCode:1},Grouptargets:{Agus:1,Apr:1,Cry:1,Currencies:1,Dec:1,Feb:1,Grp:1,GrpId:1,Id:1,In:1,InBy:1,Jan:1,Jul:1,Jun:1,Mar:1,May:1,Nov:1,Okto:1,Sep:1,Target:1,Total:1,Up:1,UpBy:1,Years:1},Lead:{Address:1,Category:1,City:1,Country:1,Custom:1,ExtSites:1,Id:1,In:1,IsBlock:1,Latitude:1,LinkId:1,ListId:1,LocatedIn:1,Location:1,Longitude:1,Manager:1,Name:1,Notes:1,OpenHours:1,Photo:1,Postal:1,Progress:1,Rating:1,Reviews:1,Search:1,State:1,Tags:1,Tool:1,Unik:1,Up:1,Url:1,User:1,VatNumber:1,Website:1},List:{Contact:1,Id:1,In:1,Nm:1,Up:1},Notif:{Action:1,Icon:1,Id:1,IsRead:1,Menu:1,Message:1,RepeatAction:1,Time:1,Title:1,ToServer:1,UserId:1},Payments:{Id:1,In:1,InBy:1,Name:1,Up:1,UpBy:1},Pluginsession:{Account:1,AccountId:1,Data:1,Id:1,In:1,TenantId:1,Tool:1,Up:1},Pluginsetting:{Back:1,Id:1,In:1,Isi:1,Kd:1,Ket:1,Kt:1,TenantId:1,Unik:1,Up:1},Productdeals:{Currencies:1,DealId:1,Id:1,In:1,InBy:1,PdtCd:1,PdtDesc:1,PdtDisc:1,PdtId:1,PdtIdNm:1,PdtImg:1,PdtPrc:1,PdtQty:1,PdtTotal:1,UnitIds:1,Up:1,UpBy:1},Products:{Currencies:1,Custom:1,Discount:1,Extra:1,FinalTotalPrice:1,Id:1,IdExt:1,IdExternal:1,Image:1,In:1,InBy:1,IsShowForm:1,ManufacturIds:1,PriceList:1,ProductCode:1,ProductDesc:1,ProductName:1,Quantity:1,Tags:1,TnId:1,TotalPrice:1,UnitIds:1,Up:1,UpBy:1},Producttags:{Id:1,In:1,InBy:1,Name:1,Up:1,UpBy:1},Statistik:{ChannelId:1,Id:1,T10B:1,T10E:1,T11B:1,T11E:1,T12B:1,T12E:1,T13B:1,T13E:1,T14B:1,T14E:1,T15B:1,T15E:1,T16B:1,T16E:1,T17B:1,T17E:1,T18B:1,T18E:1,T19B:1,T19E:1,T1B:1,T1E:1,T20B:1,T20E:1,T21B:1,T21E:1,T22B:1,T22E:1,T23B:1,T23E:1,T24B:1,T24E:1,T25B:1,T25E:1,T26B:1,T26E:1,T27B:1,T27E:1,T28B:1,T28E:1,T29B:1,T29E:1,T2B:1,T2E:1,T30B:1,T30E:1,T31B:1,T31E:1,T3B:1,T3E:1,T4B:1,T4E:1,T5B:1,T5E:1,T6B:1,T6E:1,T7B:1,T7E:1,T8B:1,T8E:1,T9B:1,T9E:1,TenantId:1,ThBln:1},Task:{BoardId:1,Color:1,Comments:1,DealId:1,GroupId:1,Hasil:1,Id:1,In:1,InBy:1,InByNm:1,Index:1,IsDone:1,KategoriId:1,Ket:1,KontakFoto:1,KontakId:1,KontakNama:1,Lampiran:1,ListId:1,ListIn:1,ListInBy:1,ListNama:1,ListUp:1,ListUpBy:1,Mulai:1,Nama:1,Owner:1,Selesai:1,ShowBoard:1,Tags:1,TnId:1,Up:1,UpBy:1,UpByNm:1},Taskboard:{BoardList:1,BoardListEntity:1,BoardListOri:1,Deskripsi:1,Id:1,In:1,InBy:1,InByNm:1,Nama:1,Up:1,UpBy:1,UpByNm:1},Taskboardlist:{BoardDeskripsi:1,BoardId:1,BoardIn:1,BoardInBy:1,BoardNama:1,BoardUp:1,BoardUpBy:1,Id:1,In:1,InBy:1,ListId:1,ListIn:1,ListInBy:1,ListNama:1,ListUp:1,ListUpBy:1,Up:1,UpBy:1,Urutan:1},Taskcategories:{Id:1,In:1,InBy:1,Name:1,Up:1,UpBy:1},Taskcomment:{BoardId:1,Id:1,In:1,InBy:1,TaskBoardId:1,TaskColor:1,TaskId:1,TaskIn:1,TaskInBy:1,TaskIndex:1,TaskKet:1,TaskKontakId:1,TaskLampiran:1,TaskListId:1,TaskMulai:1,TaskNama:1,TaskSelesai:1,TaskTags:1,TaskUp:1,TaskUpBy:1,Text:1,Up:1,UpBy:1,UserId:1},Taskcontacts:{CtId:1,Id:1,In:1,InBy:1,TaskCtgyId:1,TaskDueDate:1,TaskId:1,TaskNm:1,TaskPriId:1,TaskReminderDate:1,TaskSt:1,Up:1,UpBy:1},Tasklist:{Id:1,In:1,InBy:1,Nama:1,Up:1,UpBy:1},Taskpriorities:{Id:1,In:1,InBy:1,Nm:1,Up:1,UpBy:1},Tasktag:{Id:1,In:1,InBy:1,InByNm:1,Nama:1,Up:1,UpBy:1,UpByNm:1,isLookup:1}},NoboxChat:{Chatmessagearchives:{Id:1,Msgs:1,RoomId:1,St:1},Chatroomtagsfunnel:{Id:1,In:1,RoomId:1,Type:1,TypeId:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{ClickHere:1,FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,NeedHelp:1,OR:1,RememberMe:1,SignInButton:1,SignTo:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,Already:1,BackToLogin:1,CityId:1,ConfirmEmail:1,ConfirmPassword:1,CtryId:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,InvCd:1,MobilePhoneNumber:1,Opt:1,Password:1,StatesId:1,SubmitButton:1,Success:1,TnCityId:1,TnCtryId:1,TnEmail:1,TnIdtry:1,TnNm:1,TnPhone:1,TnSize:1,TnStateId:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},TimeAgo:{day:1,days:1,hour:1,hours:1,inPast:1,minute:1,minutes:1,month:1,months:1,seconds:1,suffixAgo:1,suffixFromNow:1,wordSeparator:1,year:1,years:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}});
}
